import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { Bank } from '../../redux-store/types/api-types';
import { KeyValue } from './InvestorWithoutPan/contributor';
import { Gridstyles, Item } from './index';
import { Notes, SubHeading } from '../investors/components';
import { getBankAddress, isOverseasBank } from '../../utils/utilityFunctions';
import { BankAccountTypeForVenture, bankType } from '../../utils/constant';
import { paymentModeDeclaration } from '../../utils/declaration';

export default function BankDetails({
  banks = [],
  paymentModeDeclaration: bEPaymentModeDeclaration,
}: {
  banks: Partial<Bank>[];
  paymentModeDeclaration: boolean;
}): JSX.Element {
  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Typography
              component="h2"
              sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
              Investor&apos;s Bank Details
            </Typography>
            {banks.length === 0 ? (
              <Grid
                xs={12}
                sm={12}
                sx={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: 'common.black',
                  textAlign: 'center',
                  my: 3,
                }}>
                No Bank Details
              </Grid>
            ) : (
              banks.map((bank, index: number) => {
                // const title = ['Bank 1 Details', 'Bank 2 Details', 'Bank 3 Details'][index];
                const bankAddress = getBankAddress(bank.address1, bank.address2, bank.address3);
                return (
                  <React.Fragment key={bank.id}>
                    {/* <SubHeading sx={{ letterSpacing: 0.5 + 'px' }}>Bank Account Details</SubHeading> */}
                    <Gridstyles>
                      <Grid
                        item
                        container
                        pt={2}
                        pb={5}
                        rowSpacing={6}
                        columnSpacing={13}
                        direction="row"
                        justifyContent="space-between"
                        alignItems="flex-start">
                        {bankType[bank.investorBankType || ''] === bankType.Domestic && (
                          <Grid item xs={12}>
                            <Notes
                              displayContent={
                                'Online LRS Payment available for AXIS, ICICI, IDFC, HDFC and Kotak only.'
                              }
                              displayContent1={
                                'For other banks, Offline mode to be selected on the payment page.'
                              }
                            />
                          </Grid>
                        )}
                        <KeyValue title={'Bank Type'} description={bank.investorBankType} />
                        {isOverseasBank(bank.investorBankType) && (
                          <KeyValue title={'SWIFT Code/IFSC'} description={bank.swiftCode} />
                        )}
                        {bankType[bank?.investorBankType || ''] === bankType.Domestic && (
                          <KeyValue title={'IFSC Code'} description={bank.ifscCode} />
                        )}
                        <KeyValue
                          title={'Bank Account Number'}
                          description={bank.bankAccountNumber}
                        />
                        {bankType[bank?.investorBankType || ''] === bankType.Domestic && (
                          <KeyValue title={'MICR Code'} description={bank.micrCode} />
                        )}
                        <KeyValue
                          title={'Account Type'}
                          description={BankAccountTypeForVenture[bank?.bankAccountType || '']}
                        />
                        <KeyValue title={'Bank Name'} description={bank.bankName} />
                        <KeyValue title={'Bank Branch'} description={bank.bankBranch} />
                        <KeyValue
                          title={`Bank Address`}
                          description={`${bankAddress}`}
                          sx={{
                            textTransform: 'capitalize',
                          }}
                        />
                        {isOverseasBank(bank?.investorBankType) && (
                          <>
                            <KeyValue title={'Bank Country'} description={bank.bankCountry} />
                            <KeyValue
                              title={'IBAN (International Bank Account Number)'}
                              description={bank.ibanNumber}
                            />
                            <KeyValue
                              title={'CIF (Customer Information File) if any'}
                              description={bank.cif}
                            />
                          </>
                        )}
                        {bankType[bank?.investorBankType || ''] === bankType.Domestic && (
                          <KeyValue
                            title={`Penny Drop Verified`}
                            description={
                              bank.pennydropCheck ? (bank.pennydropVerified ? 'Yes' : 'No') : '-'
                            }
                          />
                        )}
                        {bEPaymentModeDeclaration && (
                          <Grid item xs={12}>
                            <Item>{paymentModeDeclaration}</Item>
                          </Grid>
                        )}
                      </Grid>
                    </Gridstyles>
                  </React.Fragment>
                );
              })
            )}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
